import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function LinkIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4697 5.46965C13.4195 3.51992 16.5805 3.51992 18.5303 5.46965C20.4801 7.4194 20.4801 10.5805 18.5303 12.5303L17.2803 13.7803C16.9874 14.0732 16.5126 14.0732 16.2197 13.7803C15.9268 13.4874 15.9268 13.0126 16.2197 12.7197L17.4697 11.4697C18.8337 10.1057 18.8337 7.89428 17.4697 6.53033C16.1057 5.16637 13.8943 5.16636 12.5303 6.53032L12.5303 6.53033L11.2803 7.78032C10.9874 8.07322 10.5126 8.07322 10.2197 7.78032C9.92678 7.48743 9.92678 7.01256 10.2197 6.71966L11.4697 5.46966L11.4697 5.46965ZM7.78035 10.2197C8.07325 10.5126 8.07325 10.9874 7.78035 11.2803L6.53036 12.5303L6.53035 12.5303C5.16639 13.8943 5.1664 16.1057 6.53036 17.4697C7.89431 18.8337 10.1057 18.8337 11.4697 17.4697L12.7197 16.2197C13.0126 15.9268 13.4875 15.9268 13.7804 16.2197C14.0732 16.5126 14.0732 16.9874 13.7804 17.2803L12.5304 18.5303C10.5806 20.4801 7.41943 20.4801 5.46968 18.5303C3.51995 16.5805 3.51995 13.4195 5.46968 11.4697L5.46969 11.4697L6.71969 10.2197C7.01259 9.92678 7.48746 9.92678 7.78035 10.2197ZM14.7803 10.2803C15.0732 9.98744 15.0732 9.51256 14.7803 9.21967C14.4874 8.92678 14.0126 8.92678 13.7197 9.21967L9.21967 13.7197C8.92678 14.0126 8.92678 14.4874 9.21967 14.7803C9.51256 15.0732 9.98744 15.0732 10.2803 14.7803L14.7803 10.2803Z"
        fill="currentColor"
      />
    </svg>
  );
};
